<template>
  <div>
    <div class="card">
      <div class="card-body">
        
      </div>
      <div class="card-footer d-flex">
        <button-component @click="apply">Применить</button-component>
        <button-component kind="secondary" @click="reset">Сбросить</button-component>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonComponent from "@/common/ui/ButtonComponent";

export default {
  name: "IppsuFilters",
  components: { ButtonComponent },
  props: {
    filters: Object
  },
  data() {
    return {
      currFilters: this.filters
    };
  },
  methods: {
    apply() {
      const filters = Object.assign({}, this.currFilters);
      this.$emit('apply', filters);
    },
    reset() {
      this.currFilters = {
      };
      const filters = Object.assign({}, this.currFilters);
      this.$emit('reset', filters);
    }
  },
  created() {

  },
  mounted() {
  }
};
</script>

<style lang="scss" scoped>
.form-group{
  label{
    font-weight: 400;
  }
}

.card-footer{
  gap:16px;
  align-items: center;
  justify-content: space-between;
}
.select2::v-deep{
  .select2-container{
    width: 100%
  }
  .select2-container--default .select2-selection--single {
    height: calc(2.25rem + 2px) !important;
  }

  .select2-container--default .select2-selection--single .select2-selection__arrow {
    top: 7px !important;
  }
}
</style>